module.exports = __webpack_public_path__ + "static/img/年度最佳净水机.1fc283b0.png";